import Config from '../models/Config';
import jsonConfig from '../config';

export const config = new Config(jsonConfig);
